import { dollarsToSatoshis, satoshisToDollars } from "../../../utils";
/**
 * Converts a numeric value based on the specified type and path.
 *
 * @param type - The type of conversion to apply. Supported types are:
 *   - `"CPM"`: Converts the value from satoshis to dollars using `satoshisToDollars`.
 *   - `"PCT"`: Converts the value from dollars to satoshis using `dollarsToSatoshis`.
 * @param val - The numeric value to be converted. If undefined or not a number, the function returns `undefined`.
 * @param path - The direction of conversion. If `toService`, it converts from dollars to satoshis; if `toClient`, it converts from satoshis to dollars.
 *
 * @returns The converted value based on the type and path, or `undefined` if the input is invalid or the type | path is not supported.
 */
export const convertCurrencyValue = (type, val, path) => {
    if (typeof val !== "number" || !type) {
        return undefined;
    }
    if (type === "CPM") {
        return path === "toService" ? dollarsToSatoshis(val) : satoshisToDollars(val);
    }
    if (type === "PCT") {
        return path === "toService" ? val * 100 : val / 100;
    }
    return undefined;
};
//# sourceMappingURL=index.js.map